module.exports = __webpack_public_path__ + "k/static/img/tip_success.60a00c73.png";